import { useEffect, useState } from "react";
import API from "../services/api";

export default function Users() {

    const [users, setUsers] = useState([]);

    const [loading, setLoading] = useState(false);

    const [showResetModal, setShowResetModal] = useState(false);

    const [selectedUser, setSelectedUser] = useState(null);

    const [newPassword, setNewPassword] = useState("");

    const [confirmPassword, setConfirmPassword] = useState("");

    const [showCreateModal, setShowCreateModal] = useState(false);

    const [showEditModal, setShowEditModal] = useState(false);

    const [editUser, setEditUser] = useState({
        id: "",
        username: "",
        role: "",
        status: ""
    });

    const [newUser, setNewUser] = useState({
        username: "",
        password: "",
        confirmPassword: "",
        role: "Teacher",
        status: "Active"
    });

 


    const handleResetPassword = async () => {

        if (!newPassword || !confirmPassword) {

            alert("Please enter both passwords.");

            return;

        }

        if (newPassword !== confirmPassword) {

            alert("Passwords do not match.");

            return;

        }

        try {

            await API.post(

                "/auth/reset-password",

                {

                    username: selectedUser.username,

                    newPassword

                }

            );

            alert("Password reset successfully.");

            setShowResetModal(false);

            setNewPassword("");

            setConfirmPassword("");

            setSelectedUser(null);

        }

        catch (err) {

            if (err.response?.data?.msg) {

                alert(err.response.data.msg);

            }

            else {

                alert("Unable to reset password.");

            }

        }

    };


    const handleCreateUser = async () => {

        if (!newUser.username.trim()) {
            alert("Username is required.");
            return;
        }

        if (!newUser.password) {
            alert("Password is required.");
            return;
        }

        if (newUser.password !== newUser.confirmPassword) {
            alert("Passwords do not match.");
            return;
        }

        try {

            await API.post("/users", {
                username: newUser.username,
                password: newUser.password,
                role: newUser.role,
                status: newUser.status
            });

            alert("User created successfully.");

            setShowCreateModal(false);

            setNewUser({
                username: "",
                password: "",
                confirmPassword: "",
                role: "Teacher",
                status: "Active"
            });

            loadUsers();

        } catch (err) {

            alert(err.response?.data?.msg || "Unable to create user.");

        }

    };

        const handleUpdateUser = async () => {

            try {

                await API.put(`/users/${editUser.id}`, {
                    role: editUser.role,
                    status: editUser.status
                });

                alert("User updated successfully.");

                setShowEditModal(false);

                loadUsers();

            } catch (err) {

                alert(err.response?.data?.msg || "Unable to update user.");

            }

        };

    const loadUsers = async () => {

        try {

            setLoading(true);

            const res = await API.get("/users");

            setUsers(res.data);

        }

        catch (err) {

            alert("Unable to load users.");

        }

        finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadUsers();

    }, []);

    return (
          <>
        <div className="p-6">

                <div className="flex justify-between items-center mb-6">

                    <h1 className="text-3xl font-bold">
                        User Management
                    </h1>

                    <button
                        onClick={() => setShowCreateModal(true)}
                        className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-lg"
                    >
                        + Create User
                    </button>

                </div>

            <div className="bg-white rounded-2xl shadow overflow-hidden">

                <table className="w-full">

                    <thead className="bg-gray-100">

                        <tr>

                            <th className="p-4 text-left">

                                Username

                            </th>

                            <th className="p-4 text-left">

                                Role

                            </th>

                            <th className="p-4 text-left">

                                Status

                            </th>

                            <th className="p-4 text-left">

                                Created

                            </th>

                            <th className="p-4 text-center">

                                Action

                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            loading ?

                                (

                                    <tr>

                                        <td
                                            colSpan="5"
                                            className="text-center p-6"
                                        >

                                            Loading...

                                        </td>

                                    </tr>

                                )

                                :

                                users.map(user => (

                                    <tr
                                        key={user.id}
                                        className="border-t hover:bg-gray-50"
                                    >

                                        <td className="p-4">

                                            {user.username}

                                        </td>

                                        <td className="p-4">

                                            {user.role}

                                        </td>

                                        <td className="p-4">

                                            {user.status}

                                        </td>

                                        <td className="p-4">

                                            {

                                                new Date(

                                                    user.created_at

                                                ).toLocaleDateString()

                                            }

                                        </td>
                                        <td className="p-4 text-center">

                                            <div className="flex justify-center gap-2">

                                                <button
                                                    onClick={() => {

                                                        setEditUser({
                                                            id: user.id,
                                                            username: user.username,
                                                            role: user.role,
                                                            status: user.status
                                                        });

                                                        setShowEditModal(true);

                                                    }}
                                                    className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-2 rounded"
                                                >
                                                    Edit
                                                </button>


                                                <button
                                                    onClick={async () => {

                                                        if (window.confirm(`Are you sure you want to delete '${user.username}'?`)) {

                                                            try {

                                                                await API.delete(`/users/${user.id}`);

                                                                alert("User deleted successfully.");

                                                                loadUsers();

                                                            } catch (err) {

                                                                alert(
                                                                    err.response?.data?.msg ||
                                                                    "Unable to delete user."
                                                                );

                                                            }

                                                        }

                                                    }}
                                                    className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded"
                                                >
                                                    Delete
                                                </button>

                                                <button
                                                    onClick={() => {
                                                        setSelectedUser(user);
                                                        setShowResetModal(true);
                                                    }}
                                                    className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded"
                                                >
                                                    Reset
                                                </button>

                                            </div>

                                        </td>

                                    </tr>

                                ))

                        }

                    </tbody>

                </table>

            </div>

            </div>


            {
                showCreateModal && (

                    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">

                        <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6">

                            <h2 className="text-2xl font-bold mb-6">
                                Create User
                            </h2>

                            <input
                                placeholder="Username"
                                className="border w-full p-3 rounded mb-3"
                                value={newUser.username}
                                onChange={(e) => setNewUser({ ...newUser, username: e.target.value })}
                            />

                            <input
                                type="password"
                                placeholder="Password"
                                className="border w-full p-3 rounded mb-3"
                                value={newUser.password}
                                onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
                            />

                            <input
                                type="password"
                                placeholder="Confirm Password"
                                className="border w-full p-3 rounded mb-3"
                                value={newUser.confirmPassword}
                                onChange={(e) => setNewUser({ ...newUser, confirmPassword: e.target.value })}
                            />

                            <select
                                className="border w-full p-3 rounded mb-3"
                                value={newUser.role}
                                onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
                            >
                                <option>Admin</option>
                                <option>Teacher</option>
                                <option>Accountant</option>
                                <option>Receptionist</option>
                            </select>

                            <select
                                className="border w-full p-3 rounded mb-5"
                                value={newUser.status}
                                onChange={(e) => setNewUser({ ...newUser, status: e.target.value })}
                            >
                                <option>Active</option>
                                <option>Inactive</option>
                            </select>

                            <div className="flex justify-end gap-3">

                                <button
                                    onClick={() => setShowCreateModal(false)}
                                    className="px-5 py-2 bg-gray-300 rounded"
                                >
                                    Cancel
                                </button>

                                <button
                                    onClick={handleCreateUser}
                                    className="px-5 py-2 bg-green-600 text-white rounded"
                                >
                                    Create User
                                </button>

                            </div>

                        </div>

                    </div>

                )
            }


            {
                showEditModal && (

                    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">

                        <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6">

                            <h2 className="text-2xl font-bold mb-6">
                                Edit User
                            </h2>

                            <input
                                className="border w-full p-3 rounded mb-3 bg-gray-100"
                                value={editUser.username}
                                readOnly
                            />

                            <select
                                className="border w-full p-3 rounded mb-3"
                                value={editUser.role}
                                onChange={(e) => setEditUser({ ...editUser, role: e.target.value })}
                            >
                                <option>Admin</option>
                                <option>Teacher</option>
                                <option>Accountant</option>
                                <option>Receptionist</option>
                            </select>

                            <select
                                className="border w-full p-3 rounded mb-5"
                                value={editUser.status}
                                onChange={(e) => setEditUser({ ...editUser, status: e.target.value })}
                            >
                                <option>Active</option>
                                <option>Inactive</option>
                            </select>

                            <div className="flex justify-end gap-3">

                                <button
                                    onClick={() => setShowEditModal(false)}
                                    className="px-5 py-2 bg-gray-300 rounded"
                                >
                                    Cancel
                                </button>

                                <button
                                    onClick={handleUpdateUser}
                                    className="px-5 py-2 bg-yellow-600 text-white rounded"
                                >
                                    Save Changes
                                </button>

                            </div>

                        </div>

                    </div>

                )
            }

        {/* ==========================================
            RESET PASSWORD MODAL
        ========================================== */}

    {

        showResetModal && (

            <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">

                <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6">

                    <h2 className="text-2xl font-bold mb-6">

                        Reset Password

                    </h2>

                    <div className="mb-4">

                        <label className="font-semibold">

                            Username

                        </label>

                        <input

                            value={selectedUser?.username || ""}

                            readOnly

                            className="border w-full mt-2 p-3 rounded bg-gray-100"

                        />

                    </div>

                    <div className="mb-4">

                        <label className="font-semibold">

                            New Password

                        </label>

                        <input

                            type="password"

                            value={newPassword}

                            onChange={(e) =>
                                setNewPassword(e.target.value)
                            }

                            className="border w-full mt-2 p-3 rounded"

                        />

                    </div>

                    <div className="mb-6">

                        <label className="font-semibold">

                            Confirm Password

                        </label>

                        <input

                            type="password"

                            value={confirmPassword}

                            onChange={(e) =>
                                setConfirmPassword(e.target.value)
                            }

                            className="border w-full mt-2 p-3 rounded"

                        />

                    </div>

                            <div className="flex justify-end gap-3">

                                <button
                                    onClick={() => {
                                        setShowResetModal(false);
                                        setNewPassword("");
                                        setConfirmPassword("");
                                    }}
                                    className="px-5 py-2 rounded bg-gray-300"
                                >
                                    Cancel
                                </button>

                                <button
                                    onClick={handleResetPassword}
                                    className="px-5 py-2 rounded bg-blue-700 hover:bg-blue-800 text-white"
                                >
                                    Reset Password
                                </button>

                            </div>

                </div>

            </div>

        )

    }
        </>
    );

}

